import React from 'react';
import { resellerFeaturesData } from '../../data/distributorsData';
import { UserCheck, LayoutDashboard, Plug, ArrowRight } from 'lucide-react';

const iconMap = {
  UserCheck,
  LayoutDashboard,
  Plug
};

const ResellerSection = () => {
  return (
    <section className="py-24 bg-[#e3e4e6]/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-2 bg-[#1297fd]/10 text-[#1297fd] rounded-full text-sm font-medium mb-4">
            Autoservicio Reseller
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Mejora la autonomía del reseller{' '}
            <span className="text-[#1297fd]">mediante autoservicio</span>
          </h2>
          <p className="text-lg text-[#c3c3c5] max-w-3xl mx-auto">
            Da a los resellers la independencia para gestionar suscripciones, facturación y renovaciones por su cuenta, mientras retienes visibilidad y control.
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid md:grid-cols-3 gap-8">
          {resellerFeaturesData.map((feature, idx) => {
            const IconComponent = iconMap[feature.icon];
            return (
              <div
                key={feature.id}
                className="group bg-white rounded-3xl p-8 border border-[#e3e4e6] hover:border-[#8bcaf9] transition-all duration-500 hover:shadow-2xl hover:shadow-[#1297fd]/10 hover:-translate-y-2"
              >
                {/* Icon */}
                <div className="w-16 h-16 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300" style={{ background: 'linear-gradient(135deg, #4E95D9, #2B6FA8)' }}>
                  {IconComponent && <IconComponent className="w-8 h-8 text-white" />}
                </div>

                {/* Content */}
                <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-[#1297fd] transition-colors">
                  {feature.title}
                </h3>
                <p className="text-[#c3c3c5] leading-relaxed mb-6">
                  {feature.description}
                </p>

                {/* CTA */}
                <a
                  href="#"
                  className="inline-flex items-center text-[#1297fd] font-medium hover:text-[#40aaf8] group/link"
                >
                  Saber más
                  <ArrowRight className="ml-2 w-4 h-4 transition-transform group-hover/link:translate-x-1" />
                </a>
              </div>
            );
          })}
        </div>

        {/* Visual Banner */}
        <div className="mt-16 bg-gradient-to-br from-gray-900 to-gray-800 rounded-3xl p-8 overflow-hidden relative">
          <div className="grid md:grid-cols-2 gap-8 items-center">
            <div>
              <h3 className="text-2xl sm:text-3xl font-bold text-white mb-4">
                Fortalece las relaciones del canal
              </h3>
              <p className="text-white/70 mb-6">
                Reduce la carga de trabajo manual, y acelera el crecimiento impulsado por partners con herramientas de autoservicio.
              </p>
              <div className="flex flex-wrap gap-4">
                <div className="flex items-center gap-2 bg-white/10 rounded-full px-4 py-2">
                  <div className="w-2 h-2 bg-green-400 rounded-full" />
                  <span className="text-white text-sm">Portal 24/7</span>
                </div>
                <div className="flex items-center gap-2 bg-white/10 rounded-full px-4 py-2">
                  <div className="w-2 h-2 bg-[#40aaf8] rounded-full" />
                  <span className="text-white text-sm">Integraciones ERP</span>
                </div>
                <div className="flex items-center gap-2 bg-white/10 rounded-full px-4 py-2">
                  <div className="w-2 h-2 bg-[#8bcaf9] rounded-full" />
                  <span className="text-white text-sm">Gestión de licencias</span>
                </div>
              </div>
            </div>

            {/* Mock Portal */}
            <div className="bg-white/5 rounded-2xl p-6 border border-white/10">
              <div className="flex items-center justify-between mb-4">
                <span className="text-white font-medium">Portal Reseller</span>
                <span className="text-green-400 text-xs">Online</span>
              </div>
              <div className="space-y-3">
                {['Gestionar suscripciones', 'Ver facturas', 'Solicitar renovaciones', 'Configurar usuarios'].map((item, idx) => (
                  <div key={idx} className="flex items-center justify-between bg-white/5 rounded-lg p-3 hover:bg-white/10 transition-colors cursor-pointer">
                    <span className="text-white/80 text-sm">{item}</span>
                    <ArrowRight className="w-4 h-4 text-[#40aaf8]" />
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Decorative */}
          <div className="absolute top-0 right-0 w-64 h-64 bg-[#1297fd]/10 rounded-full blur-3xl" />
        </div>
      </div>
    </section>
  );
};

export default ResellerSection;
